import React from "react"
import { HeadingThree, HeadingTwo, Paragraph } from "buoy-core"
import styled from "styled-components"
import Arrow from "../../completion/images/Arrow"
import { colors, fontSize, fontWeight } from "buoy-theme"
import { Button } from "buoy-core"
import { pushRoute } from "../../common/route"
import { responsive } from "../../common/styledHelpers"

// KAN-4851 revisit

const FAQTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  user-select: none;
  cursor: pointer;
  ${props => props.expanded && `margin: 0 0 20px;`};
`

const Section = styled.section`
  border-bottom: 1px solid ${colors.neutralLight};
  width: 100%;
  padding: 30px 0;
`
  
  const List = styled.ul`
  ${fontSize("bodyMain")};
  line-height: 1.38;
  font-weight: ${fontWeight.light};
  ${responsive("padding", "30px 48px 30px 14px", "30px 0 30px 14px")}
`

const FaqParagraph = styled(Paragraph)`
  ${responsive("padding-right", "48px", "0")}
`

const ListItem = styled.li`
  margin-bottom: 6px;
`

const Title = styled(HeadingTwo).attrs({ alignLeft: true })`
  ${fontSize("h3")};
  margin: 0;
`

const SubHeading = styled(HeadingThree)`
  ${fontSize("bodyMain")};
  margin: 0 0 6px;
`

const SubButton = ({ action, label, maintainState }) => (
  <Button onClick={() => pushRoute(action, maintainState)}>{label}</Button>
)

const subsectionSwitch = (subsection, index) => {
  let elements = []
  if (subsection.title) {
    elements.push(
      <SubHeading key={`heading${index}`} alignLeft>
        {subsection.title}
      </SubHeading>
    )
  }
  // Formatting could change on this so it might be worth keeping
  // these types around until we have final copy.
  if (subsection.type === "list") {
    elements.push(
      <List key={`ul${index}`}>
        {subsection.content.map((item, i) => (
          <ListItem key={`li${index}${i}`}>{item}</ListItem>
        ))}
      </List>
    )
  }
  if (subsection.type === "paragraph") {
    subsection.content.map((item, i) => (
      elements.push(<FaqParagraph key={`p${i}`}>{item}</FaqParagraph>)
    ))
  }
  if (subsection.type === "button") {
    elements.push(
      <SubButton
        action={subsection.action}
        label={subsection.label}
        maintainState={subsection.maintainState}
      />
    )
  }
  return elements
}

const FAQSection = ({ title, expanded, toggleExpanded, subsections }) => (
  <Section>
    <FAQTitle expanded={expanded} onClick={toggleExpanded}>
      <Title>{title}</Title>
      <Arrow color rotation={expanded ? "180deg" : 0} />
    </FAQTitle>
    {subsections && expanded && subsections.map(s => subsectionSwitch(s))}
  </Section>
)

class FAQSectionContainer extends React.Component {
  state = {
    expanded: false,
  }

  toggleExpanded = () => {
    this.setState({
      expanded: !this.state.expanded,
    })
  }

  render() {
    return (
      <FAQSection
        toggleExpanded={this.toggleExpanded}
        {...this.props}
        {...this.state}
      />
    )
  }
}

export { FAQSectionContainer as default }



// WEBPACK FOOTER //
// ./assets/payment/components/FAQSection.js